module.exports = __webpack_public_path__ + "static/organicdandelion1-90f84c081992094dba8cb2bd25ac3720.png";